// Component: OneColumnText
// Author: Vijay Radhakrishnan
import * as React from 'react';
import OneColumnTextNPM from '@component/OneColumnText';
import { Text, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import WBRString from '@component/WbrString';

const OneColumnText = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  var OneColumnTextData = {
    title: <Text field={props.fields.Title} />,
    subTitle: <RichText field={props.fields?.Subtitle} />,
    link: (
      <>
        <RoutableLink field={props.fields.Link} useATag={true}>
          <WBRString tag="span">
            <Text field={props.fields.LinkText} />
          </WBRString>
        </RoutableLink>
        <EditableLink linkField={props.fields.Link} isEditing={isEditing} />
      </>
    ),
    backgroundImageUrl: props.fields?.BannerImage?.value.src,
    backgroundImageAlt: props.fields?.BannerImage?.value.alt,
  };

  return (
    <>
      <OneColumnTextNPM {...OneColumnTextData} />
    </>
  );
};

export default withSitecoreContext()(OneColumnText);
